import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import { ApiKeysGrid } from "./ApiKeysGrid";
import { DeleteApiKeyModal } from "./DeleteApiKeyModal";
export const ApiKeysGridSection = ({ emptyAction, emptyMessage, emptyTitle, rows, onDelete, onStatusUpdate, heightMode = 'fixed', isLoading, deleteLoading, statusUpdateLoading, isViewer = false, userCustomerId })=>{
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedApiKey, setSelectedApiKey] = useState(null);
    const handleShowDeleteConfirmation = (keyId)=>{
        const apiKey = rows.find((row)=>row.id === keyId);
        if (apiKey) {
            setSelectedApiKey(apiKey);
            setShowDeleteModal(true);
        }
    };
    const handleConfirmDelete = async ()=>{
        if (selectedApiKey) {
            await onDelete(selectedApiKey.id, selectedApiKey.productCode || '');
            setShowDeleteModal(false);
            setSelectedApiKey(null);
        }
    };
    const handleCloseDeleteModal = ()=>{
        setShowDeleteModal(false);
        setSelectedApiKey(null);
    };
    const handleStatusUpdate = async (keyId, action)=>{
        const apiKey = rows.find((row)=>row.id === keyId);
        if (apiKey) {
            await onStatusUpdate(keyId, apiKey.productCode || '', action);
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ApiKeysGrid, {
                emptyAction: emptyAction,
                emptyMessage: emptyMessage,
                emptyTitle: emptyTitle,
                handleDelete: handleShowDeleteConfirmation,
                handleStatusUpdate: handleStatusUpdate,
                heightMode: heightMode,
                rows: rows,
                isLoading: isLoading,
                isUpdating: statusUpdateLoading,
                isViewer: isViewer,
                userCustomerId: userCustomerId
            }),
            /*#__PURE__*/ _jsx(DeleteApiKeyModal, {
                isOpen: showDeleteModal,
                apiKey: selectedApiKey,
                onClose: handleCloseDeleteModal,
                onConfirm: handleConfirmDelete,
                isLoading: deleteLoading
            })
        ]
    });
};
